import React from 'react'
import CanadaTemplateDefault from 'src/components/template/ca/'
import { canadaPlanSet } from 'src/constants/planData/canadaPlanData'

export default (props) => {
  return (
    <CanadaTemplateDefault
      location={props.location}
      lang="en"
      market="canada"
      video={'https://assets.fubo.tv/marketing/lp/videos/compressed/CONCACAF_2021_LP_19s.mp4'}
      title="Watch CONCACAF World Cup Qualifiers"
      subtitle="See the Canada Men's National Team in action"
      networkSet="canada_sports"
      planCardsConfig={{
        plans: canadaPlanSet.sports,
      }}
    />
  )
}
